import isEmpty from 'lodash/isEmpty'

const checkMinDocsPersonHasBeenUploaded = ({ party, settings, localCallback, sagaCallback }) => {

    const documents = party.documents
    const minDocsPerCategory = {}
    settings?.data && settings.data.forEach(cat => minDocsPerCategory[cat.code || cat.name] = cat.minDocuments || 0)
    const docsPerCategory = {}
    documents.forEach(doc => { if (!isEmpty(doc.datas)) docsPerCategory[doc.category] = docsPerCategory[doc.category] ? docsPerCategory[doc.category] + 1 : 1 })

    const categoryMissingDocs = []
    const allMinDocsSubmitted = Object.keys(docsPerCategory).map(doc => minDocsPerCategory[doc] <= docsPerCategory[doc] ? true : categoryMissingDocs.push(doc) && false).every(min => min)

    localCallback(!allMinDocsSubmitted)
    !allMinDocsSubmitted && sagaCallback(categoryMissingDocs)
}

const checkMinDocsPartyHasBeenUploaded = ({ connectedParties, settings, localCallback, sagaCallback }) => {

    let structureIsReady = []
    let ownerIdWithWarning = []
    const owners = connectedParties.connectedPersons

    let authSignatoryOwnersDocs = {}
    let shareholderOwnersDocs = {}
    let directorOwnersDocs = {}
    let UBOOwnersDocs = {}

    let extractMinDocsPerCategory = (category, minDocsObjectByType) =>
        category.forEach(cat => { minDocsObjectByType[cat.code || cat.name] = cat.minDocuments })

    let extractOwnerDocsByCategory = (type, ownerDocsByType) =>
        connectedParties.connectedPersons
            .filter(owner => owner[type] === true)
            .forEach(owner => {
                ownerDocsByType[owner.identifier] = {}
                if (owner[type] && owner.documents)
                    owner.documents.filter(d => (d.requestStatus === 'UPLOADED' || !isEmpty(d.datas)))
                        .forEach(doc => {
                            ownerDocsByType[owner.identifier][doc.category] = ownerDocsByType[owner.identifier][doc.category] || []
                            ownerDocsByType[owner.identifier][doc.category] = [...ownerDocsByType[owner.identifier][doc.category], doc.type]
                        }
                        )
            }
            )

    let checkDocsUploadedByType = ({ ownerDocs, minDocsRequired, type }) => {
        let tempOwner
        const allOwnerTypeDocs = Object.values(ownerDocs)
        let allDocsUploaded = Object.keys(minDocsRequired)
            .map(cat => allOwnerTypeDocs.map((doc, index) => {
                tempOwner = Object.keys(ownerDocs)[index]
                let minRequiredDone = doc[cat] ? doc[cat].length >= minDocsRequired[cat] : false
                if (!minRequiredDone) ownerIdWithWarning.push(tempOwner)
                return minRequiredDone
            }))
            .reduce((sum, next) => sum && next, true)

        const valueToPush = Array.isArray(allDocsUploaded) ? allDocsUploaded.every(owner => owner === true) : allDocsUploaded
        structureIsReady.push(valueToPush)
    }


    if (!isEmpty(owners)) {

        let minDocsRequiredAuthSignatory = {}
        let minDocsRequiredShareholder = {}
        let minDocsRequiredDirector = {}
        let minDocsRequiredUBO = {}

        extractMinDocsPerCategory(settings.authSignatoryDocumentTypes || [], minDocsRequiredAuthSignatory)
        extractMinDocsPerCategory(settings.directorDocumentTypes || [], minDocsRequiredDirector)
        extractMinDocsPerCategory(settings.shareholderDocumentTypes || [], minDocsRequiredShareholder)
        extractMinDocsPerCategory(settings.UBODocumentTypes || [], minDocsRequiredUBO)

        extractOwnerDocsByCategory('authorizedSignatory', authSignatoryOwnersDocs)
        extractOwnerDocsByCategory('shareholder', shareholderOwnersDocs)
        extractOwnerDocsByCategory('director', directorOwnersDocs)
        extractOwnerDocsByCategory('ubo', UBOOwnersDocs)



        if (!isEmpty(Object.keys(authSignatoryOwnersDocs))) {
            checkDocsUploadedByType({
                ownerDocs: authSignatoryOwnersDocs,
                minDocsRequired: minDocsRequiredAuthSignatory,
                type: 'authSignatory'
            })
        }

        if (!isEmpty(Object.keys(shareholderOwnersDocs))) {
            checkDocsUploadedByType({
                ownerDocs: shareholderOwnersDocs,
                minDocsRequired: minDocsRequiredShareholder,
                type: 'shareholder'
            })
        }
        if (!isEmpty(Object.keys(directorOwnersDocs))) {
            checkDocsUploadedByType({
                ownerDocs: directorOwnersDocs,
                minDocsRequired: minDocsRequiredDirector,
                type: 'director'
            })
        }

        let hasWarning = !structureIsReady.reduce((sum, next) => sum && next, true)

        localCallback(hasWarning)
        sagaCallback(ownerIdWithWarning)
    }
}

const getPartyPath = partyType => {
    switch (partyType) {
        case 'COMPANY': return 'companies'
        case 'PERSON': return 'persons'
        case 'CONNECTED_COMPANY': return 'connected-companies'
        case 'CONNECTED_PERSON': return 'connected-persons'
        default: return
    }
}

const getPartyAccessPath = partyType => {
    switch (partyType) {
        case 'COMPANY': return 'company'
        case 'PERSON': return 'person'
        case 'CONNECTED_COMPANY':
        case 'CONNECTED_PERSON':
            return 'party'
        default: return ''
    }
}

export {
    checkMinDocsPartyHasBeenUploaded,
    checkMinDocsPersonHasBeenUploaded,
    getPartyAccessPath,
    getPartyPath,
}